import {
  MeasurementRequestComment,
  RawMeasurementRequestComment,
} from "@/types/measurementRequestComment";
import { mapRawToComment } from "./comment";

export const mapRawToMeasurementRequestComment = (
  raw: RawMeasurementRequestComment,
): MeasurementRequestComment => ({
  ...mapRawToComment(raw),
  measurementRequestId: raw.measurement_request_id,
});
